import React, {Component} from 'react';
import '../../../Home.css';
import {NextTrainBostonHeader, NextTrainBostonNav} from '../links';

let _this;

class NextTrainBostonSupport extends Component {
    constructor(props, context) {
        super(props, context);
        _this = this;

        _this.state = {
            faq: [
                {
                    question: 'Q: What is Next Train Boston?',
                    answer: 'A: A timetable app for the MBTA commuter rail and ferries. Pick your line, open a station, and see every departure with its time, direction and final stop. Tap a train to see all its stops. It works offline, has a Home Screen widget, and runs on Apple Watch.'
                },
                {
                    question: 'Q: Which lines are included?',
                    answer: 'A: All twelve commuter rail lines from South Station and North Station, and the Charlestown, Hingham, Hingham/Hull, East Boston, Lynn, Winthrop, Quincy and Winthrop/Quincy ferries. Seasonal ferries show departures during their season.'
                },
                {
                    question: 'Q: How do I set up my commute?',
                    answer: 'A: Choose your line, then tap the Commute row at the top of the station list. Pick your home station, your work station, and the hour after which you head home. Before that hour the app and the widget show trains from home to work; after it, trains from work back home.'
                },
                {
                    question: 'Q: How do I add the widget?',
                    answer: 'A: Touch and hold an empty spot on your Home Screen, tap Edit, then Add Widget, search for Next Train Boston and choose a size. With a commute set, the widget follows it; otherwise it shows the station you opened last.'
                },
                {
                    question: 'Q: Does it need an internet connection?',
                    answer: 'A: No. The full timetable is inside the app. When you are online, the app checks for a newer schedule once or twice a day and switches to it on the day it starts, so you get timetable changes without updating the app.'
                },
                {
                    question: 'Q: Why is the Track column empty?',
                    answer: 'A: The MBTA assigns tracks at South Station and North Station only minutes before departure, and those assignments are not part of the published schedule. Check the station boards or mbta.com for your track.'
                },
                {
                    question: 'Q: Does it show delays or cancellations?',
                    answer: 'A: Not yet. The app shows the published schedule. For real-time service, alerts and holiday changes, please check mbta.com or the station announcements.'
                },
                {
                    question: 'Q: Why do I see only one direction at some stations?',
                    answer: 'A: At the end of a line every train leaves in the same direction; trains arriving there are not shown as departures. For example, from Charlestown every ferry goes to Long Wharf.'
                },
                {
                    question: 'Q: Is Next Train Boston an official MBTA app?',
                    answer: 'A: No. It is an independent app by AnswerSolutions LLC, built on the MBTA\'s public schedule data. It is not affiliated with or endorsed by the MBTA.'
                },
                {
                    question: 'Q: How do I report a problem or suggest a feature?',
                    answer: 'A: Email us at support@answersolutions.net, or use the copyright line on the app\'s Info screen, which opens an email with the app version filled in.'
                },
            ]
        };
    }

    render() {
        return (
            <div className="container">
                <NextTrainBostonNav navigate={_this.props.navigate} selected="NextTrainBostonSupport"/>
                <br/>
                <NextTrainBostonHeader/>
                <br/>
                <br/>
                <div style={{padding: '20px', fontFamily: 'Arial, sans-serif'}}>
                    <div style={{marginBottom: '40px'}}>
                        <h2>FAQ And Support</h2>
                        {this.state.faq.map((item, index) => (
                            <div key={index} style={{marginBottom: '20px'}}>
                                <h3 style={{marginBottom: '8px'}}>{item.question}</h3>
                                <p>{item.answer}</p>
                                <hr style={{margin: '20px 0'}}/>
                            </div>
                        ))}
                    </div>

                    <div style={{marginBottom: '40px'}}>
                        <h2>Need Help?</h2>
                        <p>If you have questions, suggestions, or find a schedule that looks wrong, please email us at
                            support@answersolutions.net. Tell us the station, the day and the time, and we will look
                            into it.</p>
                    </div>
                    <br/>
                    <br/>
                    <br/>
                    <NextTrainBostonNav navigate={_this.props.navigate} selected="NextTrainBostonSupport" withProducts/>
                </div>
            </div>
        );
    }
}

export default NextTrainBostonSupport;
